<template>
  <div>
    <slot v-bind="{ loading }">
      <q-linear-progress v-show="loading" indeterminate />
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    task: Promise,
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    task: {
      handler(task: Promise<any>|null) {
        this.loading = false;
        if (!task) return;
        this.loading = true;
        task.finally(() => {
          this.loading = false;
        });
      },
      immediate: true,
    },
  },
});
</script>
